var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loading)?_c('b-spinner',{attrs:{"variant":"primary"}}):_c('div',[_c('LineitemSearch',{staticClass:"mb-2",attrs:{"repUserId":_vm.repUserId}}),_c('Payments',{attrs:{"payments":_vm.payments,"categoryTotals":_vm.totals}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }